import { Component, OnInit, Inject, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { LoginService } from '../../core/services/login.service';
import { SlackService } from '../../core/services/slack.service';
import { APP_CONSTANTS_TOKEN, AppConstants } from '../../core/constants';
import { ViewStateService } from '../../core/services/view-state.service';
import { FeatureFlagsService } from '../../core/services/feature-flags.service';
import { firstValueFrom } from 'rxjs';

declare let require: any;

@Component({
  selector: 'ng-login',
  template: require('./ng-login.component.html').default,
  styles: [require('!!raw-loader!sass-loader!./ng-login.component.scss').default],
  standalone: false,
})
export class NgLoginComponent implements OnInit {
  company: string;
  user: any = { name: '', pwd: '' };
  errorMessage: string = '';
  showPwd = false;

  private destroyRef = inject(DestroyRef);

  constructor(
    @Inject(Router) private router: Router,
    @Inject(AuthService) private authService: AuthService,
    @Inject(LoginService) private loginService: LoginService,
    @Inject(SlackService) private slackService: SlackService,
    @Inject(APP_CONSTANTS_TOKEN) private constants: AppConstants,
    @Inject(ViewStateService) private viewState: ViewStateService,
    @Inject(FeatureFlagsService) private featureFlags: FeatureFlagsService
  ) {
    this.company = this.constants.company;
  }

  toggleVisibility(): void {
    this.showPwd = !this.showPwd;
  }

  ngOnInit(): void {
    this.loginService.promise.then(() => {
      const state = this.loginService.getLoginState();
      if (state && state.isLoggedIn) {
        firstValueFrom(this.featureFlags.load(true)).finally(() => {
          this.router.navigateByUrl(this.viewState.getLastRouteOrFallback());
        });
      }
    });
  }

  go(path: string): void {
    window.location.href = path;
  }

  handleLogin(event: Event): void {
    event.preventDefault();

    if (this.user.name && this.user.pwd) {
      this.authService.login({ username: this.user.name, password: this.user.pwd }).subscribe({
        next: (success) => {
          this.errorMessage = '';
          this.loginService.IsLoggedIn(this.user.name, success);
          firstValueFrom(this.featureFlags.load(true)).finally(() => {
            this.router.navigateByUrl(this.viewState.getLastRouteOrFallback());
          });
        },
        error: (error) => {
          this.errorMessage = error.statusText || 'Login failed';
        },
      });
    }
  }

  // Ported slack logic if needed in future
  slackPost(name: string): void {
    const payload = {
      text: 'Tack för att just du: ' + name + ', loggar på kitstajmBeta!',
      channel: '@' + 'patrik.nilsson',
    };
    this.slackService.send(payload).pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }
}
